import { cn } from "@/lib/utils";
import Image from "next/image";

interface ImagePlaceholderProps {
  src?: string | null;
  alt: string;
  className?: string;
  aspectRatio?: "square" | "video" | "wide";
  showIcon?: boolean;
}

export function ImagePlaceholder({
  src,
  alt,
  className,
  aspectRatio = "video",
  showIcon = true
}: ImagePlaceholderProps) {
  const aspectClasses = {
    square: "aspect-square",
    video: "aspect-video", 
    wide: "aspect-[2/1]"
  };

  if (src) {
    return (
      <Image
        src={src}
        alt={alt}
        width={400}
        height={aspectRatio === "square" ? 400 : aspectRatio === "video" ? 225 : 200}
        className={cn(
          "w-full h-full object-cover object-center rounded-lg",
          aspectClasses[aspectRatio],
          className
        )}
        unoptimized
      />
    );
  }

  return (
    <div
      className={cn(
        "w-full bg-gray-200 rounded-lg flex items-center justify-center",
        aspectClasses[aspectRatio],
        className
      )}
    >
      {showIcon && (
        <div className="text-gray-400 text-center">
          <svg
            className="w-12 h-12 mx-auto mb-2"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
          <p className="text-sm text-gray-500">No image</p>
        </div>
      )}
    </div>
  );
}
